import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import 'moment-duration-format';
import moment from 'moment';
import { Link } from 'react-router-dom';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { getGlobalClasses } from '../../themes';
import { isLocalhost } from '../../util';

//containers
import AuthUserContainer from '../../containers/AuthUser';

//- UI / Form
import { Button, CircularProgress, Zoom } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';

import FormSubmitButton from '../../components/form/FormSubmitButton';
import UserPicker from '../../components/advancedForm/UserPicker';
import FormComponent from '../../components/FormComponent';
import { post } from '../../modules/utility';
import EnhancedTable from '../../components/table/EnhancedTable';
import FormTextArea from '../../components/form/FormTextArea';
import GreenChecked from '../../images/icons/greenChecked.svg';

const deviceTokenEventTypeEnum = {
	LOGIN: 'LOGIN',
	LOGOUT: 'LOGOUT',
};

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		submitButton: {
			marginTop: 20,
			fontSize: 16,
			borderRadius: '100px',
			padding: '13px 45px',
			textTransform: 'uppercase',
			marginRight: 10,
		},
		icon: {
			paddingRight: 5,
		},
		oddRow: {
			backgroundColor: '#f9f9f9',
		},
		resultsHere: {
			padding: 30,
			backgroundColor: '#f1f1f1',
			color: '#777',
			borderRadius: 10,
		},
		runningSearch: {
			paddingLeft: 20,
			display: 'flex',
			alignItems: 'center',
			fontSize: 18,
			color: '#666',
		},
		button: {
			marginRight: 5,
		},
		eventsContainer: {
			padding: 20,
		},
		eventContainer: {
			borderTop: '1px solid #eee',
			marginBottom: 3,
			paddingBottom: 3,
		},
		eventNote: {},
		eventDateTime: {
			fontSize: '80%',
			color: '#666',
		},
		tableTitle: {
			paddingTop: '40px',
			fontWeight: '400',
			fontSize: '16px',
		},
		savingSuccessful: {
			marginTop: 20,
			marginLeft: 20,
			fontSize: 16,
			color: '#2E7D32',
		},
		isSaving: {
			marginLeft: 20,
			fontSize: 16,
			color: '#1565C0',
			marginTop: 20,
		},
		greenCheckedIcon: {
			display: 'inline-block',
			width: 20,
			height: 20,
			backgroundImage: `url('${GreenChecked}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 2,
			marginLeft: 5,
		},
	};
};

const ACACIA_USER_ID = 806;
const ADAN_USER_ID = 762;

class MobileNotifications extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			fetchingDevices: false,
			sendingNotifications: false,
			sendingSuccessful: false,
		};

		if (isLocalhost) {
			this.state.userIds = [ACACIA_USER_ID, ADAN_USER_ID];
		}
	}

	handleSearchLatest = () => {
		const { showErrors } = this.props;
		this.setState({ fetchingDevices: true });

		const { userIds } = this.state;
		post({
			method: 'deviceTokenEvent.searchLatest',
			params: {
				userIds,
			},
			callback: (err, r) => {
				if (err) {
					showErrors(err);
					return this.setState({
						fetchingDevices: false,
						searchErrors: err,
					});
				}

				const deviceTokenEvents = _.get(r, 'collections.deviceTokenEventCollection');
				const userMap = _.keyBy(_.get(r, 'collections.userCollection'), 'userId');
				console.log('deviceTokenEvents', deviceTokenEvents);
				this.formatDeviceTokenEvents({ deviceTokenEvents, userMap });
				return;
			},
		});
	};

	handleSendNotification = () => {
		const { showErrors } = this.props;
		this.setState({ sendingNotifications: true, sendingSuccessful: false });

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});
		const { loggedInDeviceTokenEvents, messageText } = this.state;

		if (_.isEmpty(loggedInDeviceTokenEvents)) {
			formFieldError.userIds = `You must have at least one user logged in`;
		}

		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError, sendingNotifications: false, sendingSuccessful: false });
			return showErrors(_.values(formFieldError));
		}

		const recipientUserIds = _.map(loggedInDeviceTokenEvents, 'userId');

		setTimeout(() => {
			post({
				method: 'notification.add',
				params: {
					recipientUserIds,
					messageText,
				},
				callback: (err, r) => {
					if (err) {
						showErrors(err);
						return this.setState({
							sendingNotifications: false,
							sendingSuccessful: false,
							searchErrors: err,
						});
					}

					return this.setState({
						sendingNotifications: false,
						sendingSuccessful: true,
						searchErrors: err,
					});
				},
			});
		}, 500);
	};

	formatDeviceTokenEvents = ({ userMap, deviceTokenEvents }) => {
		const loggedInDeviceTokenEvents = [];
		const loggedOutDeviceTokenEvents = [];

		deviceTokenEvents.forEach((event) => {
			const { deviceTokenEventId, userId, deviceToken, eventType, dateCreated } = event;

			const user = userMap[userId] || { firstName: 'Missing', lastName: '' };
			const row = {
				key: deviceTokenEventId,
				userId,
				userDisplay: `${user.firstName} ${user.lastName}`,
				deviceTokenPart: deviceToken.substring(0, 10),
				eventType,
				dateCreated,
				dateCreatedDisplay: moment(dateCreated).format('M/D h:mm a'),
			};

			if (eventType === deviceTokenEventTypeEnum.LOGIN) {
				row.eventTypeDisplay = 'Logged In';
				row.statusDisplay = <span>✓</span>;
				loggedInDeviceTokenEvents.push(row);
			} else {
				row.eventTypeDisplay = 'Logged Out';
				loggedOutDeviceTokenEvents.push(row);
				row.statusDisplay = <span>&#10006;</span>;
			}
		});

		this.setState({
			fetchingDevices: false,
			loggedInDeviceTokenEvents,
			loggedOutDeviceTokenEvents,
		});
	};

	render() {
		const { classes, permissions } = this.props;
		const { loggedInDeviceTokenEvents, loggedOutDeviceTokenEvents } = this.state;

		if (!permissions || !_.includes(permissions, 'canSendMobileNotifications')) {
			return <div>You do not have valid permissions to view this page.</div>;
		}
		return (
			<>
				<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<div className={classes.globalMainHeadline}>Mobile Notifications</div>

					<div>
						<Link
							to="/dispatch/pastNotifications"
							style={{ textDecoration: 'none', paddingRight: 5 }}
						>
							<Button variant="outlined">Past Notifications</Button>
						</Link>
						<Link to="/dispatch/deviceEvents" style={{ textDecoration: 'none', paddingRight: 5 }}>
							<Button variant="outlined">Device Events</Button>
						</Link>
					</div>
				</div>
				<Paper className={classes.globalMainPaper}>
					<Grid spacing={2} container>
						<Grid item xs={12} sm={11} md={10} lg={8}>
							<div style={{ padding: '10px 0px', fontSize: '18px' }}>
								First select drivers to find the last device they logged into
							</div>

							<Grid spacing={2} container>
								<UserPicker
									{...this.setForm('userIds', 'Drivers')}
									//helpText={'Leave blank for everyone'}
									whoToShow="driversOnly"
									// userIdsToShow={myCanModifyUserIds}
									includeHidden={true}
									selectMultiple={true}
								/>

								<Grid item xs={12} sm={11} md={10} lg={8}>
									<Button
										variant="contained"
										color="primary"
										className={classes.addButton}
										onClick={this.handleSearchLatest}
									>
										Search
									</Button>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Paper>
				<Paper className={classes.globalMainPaper} style={{ minHeight: 500 }}>
					<Grid spacing={2} container>
						<Grid item xs={12} sm={11} md={10} lg={8}>
							{this.state.fetchingDevices ? <CircularProgress /> : ''}

							{loggedInDeviceTokenEvents || loggedOutDeviceTokenEvents
								? this.renderDevicePicker()
								: 'Search users first..'}
						</Grid>
					</Grid>
				</Paper>
			</>
		);
	}

	renderDevicePicker = () => {
		const { classes } = this.props;
		const {
			loggedInDeviceTokenEvents,
			loggedOutDeviceTokenEvents,
			sendingNotifications,
			sendingSuccessful,
		} = this.state;
		const columns = [
			{ label: 'Send', sortId: undefined, displayId: 'statusDisplay' },
			{ label: 'Employee', sortId: 'requestorDisplay', displayId: 'userDisplay' },
			{ label: 'Last Status', sortId: 'typeDisplay', displayId: 'eventTypeDisplay' },
			{ label: 'Date', sortId: 'totalDaysSort', displayId: 'dateCreatedDisplay' },
			{ label: 'Device Id', sortId: 'rangeSort', displayId: 'deviceTokenPart' },
		];

		return (
			<div>
				<div className={classes.tableTitle} style={{ paddingTop: '10px' }}>
					<span style={{ color: 'green', fontWeight: 'bold' }}>✓</span> Logged in drivers that will
					get a notification
				</div>
				<EnhancedTable
					rows={loggedInDeviceTokenEvents}
					columns={columns}
					isDense={true}
					defaultOrder={'desc'}
					defaultOrderBy={'dateCreated'}
				/>

				{!_.isEmpty(loggedOutDeviceTokenEvents) && (
					<>
						<div className={classes.tableTitle}>
							<span style={{ color: 'red' }}>&#10006;</span> Logged out drivers that will NOT get a
							notification
						</div>
						<EnhancedTable
							rows={loggedOutDeviceTokenEvents}
							columns={columns}
							isDense={true}
							defaultOrder={'desc'}
							defaultOrderBy={'dateCreated'}
						/>
					</>
				)}

				<div className={classes.tableTitle}>Type message below</div>
				<FormTextArea {...this.setForm('messageText', 'Message text', true)} rows={3} />

				<Zoom
					in={sendingNotifications}
					style={{ transitionDelay: sendingNotifications ? '0ms' : '0ms' }}
					mountOnEnter
					unmountOnExit
				>
					<div className={classes.isSaving}>
						<CircularProgress style={{ verticalAlign: 'middle' }} />
						<span style={{ paddingLeft: 10 }}>Sending notifications...</span>
					</div>
				</Zoom>

				<Zoom
					in={sendingSuccessful}
					style={{ transitionDelay: sendingSuccessful ? '250ms' : '0ms' }}
				>
					<div className={classes.savingSuccessful}>
						<div className={classes.greenCheckedIcon} />
						<span style={{ paddingLeft: 10 }}>Notifications successfully sent to mobile app.</span>
					</div>
				</Zoom>

				<FormSubmitButton
					onClick={this.handleSendNotification}
					buttonText={`Send Notification`}
					isDisabled={sendingNotifications}
				/>
			</div>
		);
	};
}

MobileNotifications.propTypes = {
	showErrors: PropTypes.func.isRequired,
	authUser: PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles), AuthUserContainer])(MobileNotifications);
